import { render, staticRenderFns } from "./OpportunityColumn.vue?vue&type=template&id=59d97bee&scoped=true&"
import script from "./OpportunityColumn.vue?vue&type=script&lang=js&"
export * from "./OpportunityColumn.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityColumn.vue?vue&type=style&index=0&id=59d97bee&scoped=true&lang=css&"
import style1 from "./OpportunityColumn.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d97bee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VDivider,VIcon})
